import React from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, Hidden, Typography } from '@mui/material';
import Logo from 'src/components/Logo';

const PREFIX = 'TopBar';

const classes = {
  root: `${PREFIX}-root`,
  toolbar: `${PREFIX}-toolbar`,
  logo: `${PREFIX}-logo`,
  link: `${PREFIX}-link`,
  divider: `${PREFIX}-divider`
};

const StyledAppBar = styled(AppBar)((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    backgroundColor: theme.palette.background.default,
  },

  [`& .${classes.toolbar}`]: {
    height: 64,
  },

  [`& .${classes.logo}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.link}`]: {
    fontWeight: theme.typography.fontWeightMedium,
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },

  [`& .${classes.divider}`]: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  }
}));

const TopBar = ({ className, ...rest }) => {


  return (
    <StyledAppBar className={clsx(classes.root, className)} color="default" {...rest}>
      <Toolbar className={classes.toolbar}>
        <Logo className={classes.logo} />
        <Hidden lgDown>
          <Typography variant="caption" color="textSecondary"></Typography>
        </Hidden>
      </Toolbar>
    </StyledAppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
};

export default TopBar;
